module.exports = __webpack_public_path__ + "img/1723616670810-WhatsApp Image 2024-08-14 at 10.14.51.jpeg.89033cc7.webp";